import { render } from "./TechItsBlogsArticlesComp.vue?vue&type=template&id=3334ea7f&scoped=true"
import script from "./TechItsBlogsArticlesComp.vue?vue&type=script&lang=js"
export * from "./TechItsBlogsArticlesComp.vue?vue&type=script&lang=js"

import "./TechItsBlogsArticlesComp.vue?vue&type=style&index=0&id=3334ea7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3334ea7f"]])

export default __exports__